/* gl_multi_select.module.js */

"use strict";
let angular = require("angular");

module.exports = angular.module("gl_multi_select", ["gl_chosen"]);


/* Generated Dependencies */
module.exports.directive("glMultiSelect", require('././directives/gl_multi_select.directive.js'));